
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organizations/[organizationId]/edit/settings/memberships",
      function () {
        return require("private-next-pages/organizations/[organizationId]/edit/settings/memberships/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organizations/[organizationId]/edit/settings/memberships"])
      });
    }
  